import { render, staticRenderFns } from "./RankingPeople.vue?vue&type=template&id=b6b034d8"
import script from "./RankingPeople.vue?vue&type=script&setup=true&lang=js"
export * from "./RankingPeople.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports